var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncomeDriverCalculatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9178 48.3651C14.4554 49.7452 4.56517 45.605 1.3887 35.1376C-2.2713 23.2938 1.25852 7.87534 12.5101 2.49283C26.3095 -3.83823 45.1116 6.65154 47.8231 22.773C49.735 37.3397 35.7756 47.1934 23.9215 48.3614",
    fill: "#FEC508"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7794_17475",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 32,
    height: 33
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8.62305H8V40.6231H40V8.62305Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7794_17475)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7794_17475",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 32,
    height: 33
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8.62305H8V40.6231H40V8.62305Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7794_17475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.548 29.7302C23.548 28.9584 21.4272 27.8729 17.9825 27.8729C14.5378 27.8729 12.417 28.9521 12.417 29.7302C12.417 30.5082 14.5378 31.5874 17.9825 31.5874C21.4272 31.5874 23.548 30.5082 23.548 29.7302ZM12.417 32.5098C12.417 33.2815 14.5378 34.367 17.9825 34.367C21.4272 34.367 23.548 33.2878 23.548 32.5098V31.2109C22.337 32.058 20.1158 32.5098 17.9825 32.5098C15.8491 32.5098 13.628 32.058 12.417 31.2109V32.5098ZM12.417 35.2957C12.417 36.0674 14.5378 37.1529 17.9825 37.1529C21.4272 37.1529 23.548 36.0737 23.548 35.2957V33.9968C22.337 34.8439 20.1158 35.2957 17.9825 35.2957C15.8491 35.2957 13.628 34.8439 12.417 33.9968V35.2957ZM26.9237 18.0094L29.1072 20.1866L33.148 16.1521C33.33 15.9702 33.33 15.6753 33.148 15.4933C32.966 15.3113 32.6711 15.3113 32.4892 15.4933L29.1072 18.8752L27.5825 17.3443C27.4005 17.1623 27.1056 17.1623 26.9237 17.3443C26.7417 17.5262 26.7417 17.8211 26.9237 18.0031V18.0094ZM24.4703 17.6768C24.4703 14.6086 26.9676 12.1113 30.0358 12.1113C33.1041 12.1113 35.6013 14.6086 35.6013 17.6768C35.6013 20.7451 33.1041 23.2423 30.0358 23.2423C26.9676 23.2423 24.4703 20.7451 24.4703 17.6768ZM30.0358 26.0219C33.4805 26.0219 35.6013 24.9427 35.6013 24.1647C35.6013 23.7505 34.9927 23.2486 33.9072 22.8784C32.828 23.6878 31.4915 24.1647 30.0421 24.1647C28.5927 24.1647 27.2562 23.6815 26.177 22.8784C25.0852 23.2549 24.4829 23.7568 24.4829 24.1647C24.4829 24.9364 26.6037 26.0219 30.0484 26.0219H30.0358ZM24.4703 26.9505C24.4703 27.7223 26.5911 28.8078 30.0358 28.8078C33.4805 28.8078 35.6013 27.7286 35.6013 26.9505V25.6517C34.3903 26.4988 32.1692 26.9505 30.0358 26.9505C27.9025 26.9505 25.6813 26.4988 24.4703 25.6517V26.9505ZM24.4703 29.7302C24.4703 30.5019 26.5911 31.5874 30.0358 31.5874C33.4805 31.5874 35.6013 30.5082 35.6013 29.7302V28.4313C34.3903 29.2784 32.1692 29.7302 30.0358 29.7302C27.9025 29.7302 25.6813 29.2784 24.4703 28.4313V29.7302ZM24.4703 32.5098C24.4703 33.2815 26.5911 34.367 30.0358 34.367C33.4805 34.367 35.6013 33.2878 35.6013 32.5098V31.2109C34.3903 32.058 32.1692 32.5098 30.0358 32.5098C27.9025 32.5098 25.6813 32.058 24.4703 31.2109V32.5098ZM24.4703 33.9968C25.6813 34.8439 27.9025 35.2957 30.0358 35.2957C32.1692 35.2957 34.3903 34.8439 35.6013 33.9968V35.2957C35.6013 36.0674 33.4805 37.1529 30.0358 37.1529C26.5911 37.1529 24.4703 36.0737 24.4703 35.2957V33.9968Z",
    fill: "#00625F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeDriverCalculatorIcon);
export default __webpack_public_path__ + "static/media/income-driver-calculator-icon.b3dea3ba95fc329c7cccdc3678991521.svg";
export { ForwardRef as ReactComponent };